import Spinner from '@carvana/ds-spinner';
import React from 'react';

type OwnProps = React.HTMLProps<HTMLDivElement> & {
  noPadding?: boolean;
};

export default function Loader({ noPadding = false, ...props }: OwnProps) {
  return (
    <div className={noPadding ? undefined : 'py-[50px]'} {...props}>
      <div className="opacity-100 relative mx-auto w-[100px]">
        <Spinner />
      </div>
    </div>
  );
}
